<template>
  <div class="container-list">
    <div class="common-page common-head">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="flex">
      <!-- <unitList @select="getUnit"></unitList> -->
      <div class="flex1">
        <div class="common-page common-list">
          <el-table :data="list" class="">
            <el-table-column
              prop="c_point_number"
              label="巡查点编号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="c_point_name"
              label="巡查点名称"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="c_point_addr"
              align="center"
              label="巡查点位置"
            >
            </el-table-column>
            <el-table-column
              prop="c_point_states"
              align="c_point_error"
              label="是否异常"
            >
              isNormal
              <template slot-scope="scope">{{
                $map.isNormal[scope.row.c_point_error]
              }}</template>
            </el-table-column>
            <el-table-column
              prop="c_commit_name"
              align="center"
              label="上报人姓名"
            >
            </el-table-column>
            <el-table-column
              prop="c_commit_time"
              align="center"
              label="创建时间"
            >
            </el-table-column>
            <el-table-column prop="c_point_states" align="center" label="状态">
              <template slot-scope="scope">{{
                $map.checkstates[scope.row.c_point_states]
              }}</template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="pageChange"
          :page-size="10"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {getCompanyList,switchCompany} from '../../api/company'
import unitList from "@/components/unitList";
export default {
  props: ["c_num"],
  data() {
    return {
      list: [],
      params: {
        page: 1,
        c_point_name: "",
        c_point_addr: "",
        c_point_error: "",
        start_time: "",
        c_point_number: "",
        end_time: "",
      },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("recordSearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.params.c_company_num = this.c_num;
    this.getList();
  },
  components: {
    unitList,
  },
  methods: {
    cancle() {
      this.resetSearch();
    },
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      this.$post("/record/recordlists", this.params).then((res) => {
        this.list = res.list;
        this.total = res.count;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    getUnit() {},
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = {
        page: 1,
        c_company_num: "",
        c_point_name: "",
        c_point_addr: "",
        c_point_error: "",
        start_time: "",
        c_point_number: "",
        end_time: "",
        ...this.$refs.searchForm.models,
      };
      this.getList();
    },
  },
};
</script>

<style scoped>
.common-head {
  border: none;
}
.common-page {
  padding: 0;
}
</style>
